import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-ba0ed71e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = { class: "panel mt-6 has-text-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "fas fa-tasks" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-project-diagram" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlterarIdioma = _resolveComponent("AlterarIdioma")!
  const _component_ExportarParaCsvComponent = _resolveComponent("ExportarParaCsvComponent")!
  const _component_BotaoDarkComponent = _resolveComponent("BotaoDarkComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("h1", null, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('alt_logo')
      }, null, 8, _hoisted_1)
    ]),
    _createVNode(_component_AlterarIdioma),
    _createVNode(_component_ExportarParaCsvComponent, {
      desabilitar: !_ctx.exibirBotaoExportar,
      json: _ctx.jsonExportacao,
      "texto-botao": _ctx.$t('exportar_tarefas'),
      "titulo-csv": _ctx.nomeArquivoCsv
    }, null, 8, ["desabilitar", "json", "texto-botao", "titulo-csv"]),
    _createVNode(_component_BotaoDarkComponent, {
      class: "btn-dark",
      onAlterarTema: _ctx.alterarTema
    }, null, 8, ["onAlterarTema"]),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" tarefas ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/projetos",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" projetos ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}